import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ErrorBoundary } from './components/ErrorBoundary'

// ─── Supabase auth redirect shim ────────────────────────────────────────────
// Supabase email confirmation links land on:
//   site.com/#access_token=xxx&refresh_token=yyy&type=signup
//
// Problem: createClient() calls initialize() which is ASYNC — it reads the
// hash on the next microtask. If we rewrite the hash synchronously first,
// Supabase never sees the token. We must extract the tokens BEFORE rewriting,
// store them in sessionStorage, then let AuthCallback manually set the session.
const rawHash = window.location.hash;
if (rawHash.includes('access_token=') || rawHash.includes('error_description=')) {
  const params = new URLSearchParams(rawHash.replace(/^#/, ''));
  const accessToken  = params.get('access_token');
  const refreshToken = params.get('refresh_token') ?? '';
  if (accessToken) {
    // sessionStorage.setItem throws QuotaExceededError on iOS Safari private
    // browsing — wrap defensively so the shim never crashes the page.
    try {
      sessionStorage.setItem('_sb_access_token',  accessToken);
      sessionStorage.setItem('_sb_refresh_token', refreshToken);
    } catch {
      // Storage unavailable — AuthCallback will find no token and show an
      // error page instead of the app crashing silently.
    }
  }
  // Rewrite so HashRouter renders /auth/callback instead of a 404 route
  window.history.replaceState(
    null,
    '',
    window.location.pathname + '#/auth/callback'
  );
}
// ────────────────────────────────────────────────────────────────────────────

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
